import { baseApi } from './baseApi';

export const notesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotes: builder.query({
      query: ({ entityType, entityId }) =>
        `/notes?entity_type=${encodeURIComponent(entityType)}&entity_id=${encodeURIComponent(entityId)}`,
      providesTags: (result, error, { entityType, entityId }) => [
        { type: 'Note', id: `${entityType}-${entityId}` },
      ],
    }),

    getNote: builder.query({
      query: (id) => `/notes/${id}`,
      providesTags: (result, error, id) => [{ type: 'Note', id }],
    }),

    transcribeNote: builder.mutation({
      query: ({ formData }) => ({
        url: '/notes/transcribe',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: (result) =>
        result
          ? [{ type: 'Note', id: `${result.entity_type}-${result.entity_id}` }]
          : [],
    }),

    createNote: builder.mutation({
      query: ({ entityType, entityId, content }) => ({
        url: '/notes',
        method: 'POST',
        body: { entity_type: entityType, entity_id: entityId, content },
      }),
      invalidatesTags: (result, error, { entityType, entityId }) => [
        { type: 'Note', id: `${entityType}-${entityId}` },
      ],
    }),

    updateNote: builder.mutation({
      query: ({ id, content }) => ({
        url: `/notes/${id}`,
        method: 'PATCH',
        body: { content },
      }),
      invalidatesTags: (result) =>
        result
          ? [
              { type: 'Note', id: result.id },
              { type: 'Note', id: `${result.entity_type}-${result.entity_id}` },
            ]
          : [],
    }),

    deleteNote: builder.mutation({
      query: (id) => ({
        url: `/notes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Note' }],
    }),

    enhanceNote: builder.mutation({
      query: (id) => ({
        url: `/notes/${id}/enhance`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetNotesQuery,
  useGetNoteQuery,
  useTranscribeNoteMutation,
  useCreateNoteMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
  useEnhanceNoteMutation,
} = notesApi;
